function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { PropertyGroup } from './PropertyGroup';
import { FIELD_TYPES } from '../../../constants/fieldTypes';
import { CURRENCIES } from './CurrenciesList';

/**
 * Repeater fields property component
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const RepeaterFieldsProperty = _ref => {
  let {
    field,
    updateRepeaterField,
    removeRepeaterField,
    addRepeaterField
  } = _ref;
  if (field.type !== 'repeater') {
    return null;
  }

  // Get all field types except container fields and layout fields that shouldn't be in repeaters
  const excludedTypes = ['repeater', 'section', 'tabs', 'columns', 'collapsible', 'divider', 'heading', 'paragraph', 'hidden'];
  const availableFieldTypes = Object.entries(FIELD_TYPES).filter(_ref2 => {
    let [key] = _ref2;
    return !excludedTypes.includes(key);
  }).map(_ref3 => {
    let [key, type] = _ref3;
    return {
      value: key,
      label: type.label
    };
  });
  const handleTypeChange = (index, newType) => {
    const repeaterField = field.fields[index];
    const updates = {
      type: newType
    };

    // Initialize type-specific properties
    if (['select', 'radio', 'checkbox'].includes(newType)) {
      updates.options = repeaterField.options || [{
        label: 'Option 1',
        value: 'option1'
      }];
    } else {
      delete updates.options;
    }
    if (newType === 'currency') {
      updates.currency = repeaterField.currency || 'USD';
    } else {
      delete updates.currency;
    }
    if (newType === 'price') {
      updates.currencySymbol = repeaterField.currencySymbol || '$';
      updates.decimalPlaces = repeaterField.decimalPlaces !== undefined ? repeaterField.decimalPlaces : 2;
    } else {
      delete updates.currencySymbol;
      delete updates.decimalPlaces;
    }
    if (newType === 'switch') {
      updates.defaultValue = repeaterField.defaultValue !== undefined ? repeaterField.defaultValue : false;
    }
    if (newType === 'select') {
      updates.multiselect = repeaterField.multiselect || false;
    } else {
      delete updates.multiselect;
    }
    updateRepeaterField(index, updates);
  };
  const updateOption = (fieldIndex, optionIndex, key, value) => {
    const repeaterField = field.fields[fieldIndex];
    const newOptions = [...(repeaterField.options || [])];
    newOptions[optionIndex] = _objectSpread(_objectSpread({}, newOptions[optionIndex]), {}, {
      [key]: value
    });
    updateRepeaterField(fieldIndex, {
      options: newOptions
    });
  };
  const removeOption = (fieldIndex, optionIndex) => {
    const repeaterField = field.fields[fieldIndex];
    const newOptions = [...(repeaterField.options || [])];
    newOptions.splice(optionIndex, 1);
    updateRepeaterField(fieldIndex, {
      options: newOptions
    });
  };
  const addOption = fieldIndex => {
    const repeaterField = field.fields[fieldIndex];
    const newOptions = [...(repeaterField.options || []), {
      label: `Option ${(repeaterField.options || []).length + 1}`,
      value: `option${(repeaterField.options || []).length + 1}`
    }];
    updateRepeaterField(fieldIndex, {
      options: newOptions
    });
  };
  return /*#__PURE__*/_jsxs(PropertyGroup, {
    children: [/*#__PURE__*/_jsx("label", {
      className: "section-label",
      children: "Repeater Fields"
    }), /*#__PURE__*/_jsx("p", {
      className: "conditions-help",
      children: "Configure the fields that will be repeated for each item"
    }), /*#__PURE__*/_jsx("div", {
      className: "repeater-fields-section",
      children: field.fields?.map((repeaterField, index) => {
        const fieldTypeData = FIELD_TYPES[repeaterField.type] || {};
        const supportsOptions = fieldTypeData.supportsOptions || false;
        const isCurrency = repeaterField.type === 'currency';
        const isPrice = repeaterField.type === 'price';
        const isSwitch = repeaterField.type === 'switch';
        const isSelect = repeaterField.type === 'select';
        const hasDefaultValue = !['select', 'radio', 'checkbox', 'switch'].includes(repeaterField.type);
        return /*#__PURE__*/_jsxs("div", {
          className: "repeater-field-item",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "repeater-field-header",
            children: [/*#__PURE__*/_jsxs("span", {
              className: "field-number",
              children: ["Field ", index + 1]
            }), /*#__PURE__*/_jsx("button", {
              type: "button",
              onClick: () => removeRepeaterField(index),
              className: "remove-condition-btn",
              title: "Remove field",
              children: "\xD7"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "repeater-field-config",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "config-row",
              children: [/*#__PURE__*/_jsx("label", {
                className: "config-label",
                children: "Label"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: repeaterField.label,
                onChange: e => updateRepeaterField(index, {
                  label: e.target.value
                }),
                className: "config-input",
                placeholder: "Field label"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "config-row",
              children: [/*#__PURE__*/_jsx("label", {
                className: "config-label",
                children: "Type"
              }), /*#__PURE__*/_jsx("select", {
                value: repeaterField.type,
                onChange: e => handleTypeChange(index, e.target.value),
                className: "config-input",
                children: availableFieldTypes.map(type => /*#__PURE__*/_jsx("option", {
                  value: type.value,
                  children: type.label
                }, type.value))
              })]
            }), !['switch', 'rating', 'range'].includes(repeaterField.type) && /*#__PURE__*/_jsxs("div", {
              className: "config-row",
              children: [/*#__PURE__*/_jsx("label", {
                className: "config-label",
                children: "Placeholder"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: repeaterField.placeholder || '',
                onChange: e => updateRepeaterField(index, {
                  placeholder: e.target.value
                }),
                className: "config-input",
                placeholder: "Placeholder text"
              })]
            }), hasDefaultValue && /*#__PURE__*/_jsxs("div", {
              className: "config-row",
              children: [/*#__PURE__*/_jsx("label", {
                className: "config-label",
                children: "Default Value"
              }), /*#__PURE__*/_jsx("input", {
                type: repeaterField.type === 'number' ? 'number' : 'text',
                value: repeaterField.defaultValue || '',
                onChange: e => updateRepeaterField(index, {
                  defaultValue: e.target.value
                }),
                className: "config-input",
                placeholder: "Default value"
              })]
            }), isSwitch && /*#__PURE__*/_jsx("div", {
              className: "config-row",
              children: /*#__PURE__*/_jsxs("label", {
                className: "checkbox-label",
                children: [/*#__PURE__*/_jsx("input", {
                  type: "checkbox",
                  checked: repeaterField.defaultValue === true || repeaterField.defaultValue === 'true',
                  onChange: e => updateRepeaterField(index, {
                    defaultValue: e.target.checked
                  })
                }), "Default to checked"]
              })
            }), supportsOptions && /*#__PURE__*/_jsxs("div", {
              className: "config-row",
              children: [/*#__PURE__*/_jsx("label", {
                className: "config-label",
                children: "Options"
              }), /*#__PURE__*/_jsxs("div", {
                className: "repeater-options-container",
                children: [repeaterField.options?.map((option, optIndex) => /*#__PURE__*/_jsxs("div", {
                  className: "repeater-option-row",
                  children: [/*#__PURE__*/_jsx("input", {
                    type: "text",
                    placeholder: "Label",
                    value: option.label,
                    onChange: e => updateOption(index, optIndex, 'label', e.target.value),
                    className: "config-input repeater-option-input"
                  }), /*#__PURE__*/_jsx("input", {
                    type: "text",
                    placeholder: "Value",
                    value: option.value,
                    onChange: e => updateOption(index, optIndex, 'value', e.target.value),
                    className: "config-input repeater-option-input"
                  }), /*#__PURE__*/_jsx("button", {
                    type: "button",
                    onClick: () => removeOption(index, optIndex),
                    className: "remove-condition-btn remove-btn-sm",
                    children: "\xD7"
                  })]
                }, optIndex)), /*#__PURE__*/_jsx("button", {
                  type: "button",
                  onClick: () => addOption(index),
                  className: "add-condition-btn repeater-add-option-btn",
                  children: "+ Add Option"
                })]
              })]
            }), isSelect && /*#__PURE__*/_jsx("div", {
              className: "config-row",
              children: /*#__PURE__*/_jsxs("label", {
                className: "checkbox-label",
                children: [/*#__PURE__*/_jsx("input", {
                  type: "checkbox",
                  checked: repeaterField.multiselect || false,
                  onChange: e => updateRepeaterField(index, {
                    multiselect: e.target.checked
                  })
                }), "Enable Multiple Selection"]
              })
            }), isCurrency && /*#__PURE__*/_jsxs("div", {
              className: "config-row",
              children: [/*#__PURE__*/_jsx("label", {
                className: "config-label",
                children: "Currency"
              }), /*#__PURE__*/_jsx("select", {
                value: repeaterField.currency || 'USD',
                onChange: e => updateRepeaterField(index, {
                  currency: e.target.value
                }),
                className: "config-input",
                children: CURRENCIES.map(curr => /*#__PURE__*/_jsxs("option", {
                  value: curr.code,
                  children: [curr.code, " - ", curr.name, " (", curr.symbol, ")"]
                }, curr.code))
              })]
            }), isPrice && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs("div", {
                className: "config-row",
                children: [/*#__PURE__*/_jsx("label", {
                  className: "config-label",
                  children: "Currency Symbol"
                }), /*#__PURE__*/_jsx("select", {
                  value: repeaterField.currencySymbol || '$',
                  onChange: e => updateRepeaterField(index, {
                    currencySymbol: e.target.value
                  }),
                  className: "config-input",
                  children: CURRENCIES.map(curr => /*#__PURE__*/_jsxs("option", {
                    value: curr.symbol,
                    children: [curr.symbol, " - ", curr.name, " (", curr.code, ")"]
                  }, curr.code))
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "config-row",
                children: [/*#__PURE__*/_jsx("label", {
                  className: "config-label",
                  children: "Decimal Places"
                }), /*#__PURE__*/_jsx("input", {
                  type: "number",
                  min: "0",
                  max: "10",
                  value: repeaterField.decimalPlaces !== undefined ? repeaterField.decimalPlaces : 2,
                  onChange: e => updateRepeaterField(index, {
                    decimalPlaces: parseInt(e.target.value) || 2
                  }),
                  className: "config-input"
                })]
              })]
            }), repeaterField.type === 'range' && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs("div", {
                className: "config-row",
                children: [/*#__PURE__*/_jsx("label", {
                  className: "config-label",
                  children: "Min"
                }), /*#__PURE__*/_jsx("input", {
                  type: "number",
                  value: repeaterField.min !== undefined ? repeaterField.min : 0,
                  onChange: e => updateRepeaterField(index, {
                    min: parseFloat(e.target.value) || 0
                  }),
                  className: "config-input"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "config-row",
                children: [/*#__PURE__*/_jsx("label", {
                  className: "config-label",
                  children: "Max"
                }), /*#__PURE__*/_jsx("input", {
                  type: "number",
                  value: repeaterField.max !== undefined ? repeaterField.max : 100,
                  onChange: e => updateRepeaterField(index, {
                    max: parseFloat(e.target.value) || 100
                  }),
                  className: "config-input"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "config-row",
                children: [/*#__PURE__*/_jsx("label", {
                  className: "config-label",
                  children: "Step"
                }), /*#__PURE__*/_jsx("input", {
                  type: "number",
                  value: repeaterField.step !== undefined ? repeaterField.step : 1,
                  onChange: e => updateRepeaterField(index, {
                    step: parseFloat(e.target.value) || 1
                  }),
                  className: "config-input"
                })]
              })]
            }), repeaterField.type === 'rating' && /*#__PURE__*/_jsxs("div", {
              className: "config-row",
              children: [/*#__PURE__*/_jsx("label", {
                className: "config-label",
                children: "Max Rating"
              }), /*#__PURE__*/_jsx("input", {
                type: "number",
                min: "1",
                max: "10",
                value: repeaterField.maxRating !== undefined ? repeaterField.maxRating : 5,
                onChange: e => updateRepeaterField(index, {
                  maxRating: parseInt(e.target.value) || 5
                }),
                className: "config-input"
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "config-row",
              children: /*#__PURE__*/_jsxs("label", {
                className: "checkbox-label",
                children: [/*#__PURE__*/_jsx("input", {
                  type: "checkbox",
                  checked: repeaterField.required || false,
                  onChange: e => updateRepeaterField(index, {
                    required: e.target.checked
                  })
                }), "Required field"]
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "config-row",
              children: [/*#__PURE__*/_jsx("label", {
                className: "config-label",
                children: "Help Text"
              }), /*#__PURE__*/_jsx("textarea", {
                value: repeaterField.helpText || '',
                onChange: e => updateRepeaterField(index, {
                  helpText: e.target.value
                }),
                className: "config-input",
                placeholder: "Help text",
                rows: 2
              })]
            })]
          })]
        }, repeaterField.id);
      })
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: addRepeaterField,
      className: "add-condition-btn",
      children: "+ Add Field"
    })]
  });
};